import { cn } from '@Utils/cn';

export interface FlowStagePillProps {
  name: string;
  isActive: boolean;
  onClick?: () => void;
  className?: string;
}

export function FlowStagePill({
  name,
  isActive,
  onClick,
  className,
}: FlowStagePillProps) {
  return (
    <div
      role={onClick ? 'button' : undefined}
      onClick={onClick}
      className={cn(
        'flex items-center justify-center rounded-full px-5 py-3 font-medium transition-colors',
        isActive &&
          'bg-[#caab6a] text-white shadow-[0_20px_25px_0_rgba(0,0,0,0.1),0_8px_10px_0_rgba(0,0,0,0.1)]',
        !isActive && 'text-zinc-200 opacity-80',
        onClick && 'cursor-pointer hover:opacity-90',
        className,
      )}
    >
      {name}
    </div>
  );
}
